import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@price-management-console/permissions';
import { filter, of, switchMap, take } from 'rxjs';

export const hasAnyPermissionGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  // Wait until permissions are finished loading
  return toObservable(permissionService.isLoading).pipe(
    filter((isLoading) => !isLoading),
    take(1),
    switchMap(() => {
      const perms = permissionService.permissions();
      // Check if the permissions map is loaded but empty.
      // This happens with a 204 response from the permissions endpoint.
      if (perms && Object.keys(perms).length === 0) {
        // User has no permissions, redirect to unauthorized page.
        return of(router.createUrlTree(['/unauthorized']));
      }

      // User has permissions, allow access to the authenticated layout.
      return of(true);
    })
  );
};
